import * as React from 'react'
import { Edit, ReferenceField, TextField, SimpleForm, TextInput, useRecordContext } from 'react-admin'

import { Account } from 'shared/types'
import { Divider, Typography } from 'antd'
import { PageTitle, SaveOnlyToolbar } from 'shared/react-admin'
import { SettingsGroup } from 'shared/organisms/settings_group'

export const SettingsEdit = () => {
  return (
    <Edit redirect={false} title={<PageTitle resource="Account" source="name" />}>
      <SimpleForm toolbar={<SaveOnlyToolbar />}>
        <AccountHeader />

        <Divider />
        <AccountSettings />
        {/* <SettingsGroup name="Social" description="TODO: Write copy based on the intent behind why this field exists">
          <TextInput source="twitter" fullWidth />
        </SettingsGroup> */}
      </SimpleForm>
    </Edit>
  )
}

const AccountSettings: React.FC = () => {
  const record = useRecordContext()

  return (
    record && (
      <div>
        <SettingsGroup name="General Preferences" description="Basic information about your account.">
          <TextInput source="name" fullWidth />
          <TextInput source="website" fullWidth />
          <TextInput disabled source="billingContactEmail" fullWidth />
        </SettingsGroup>
        <SettingsGroup name="Billing Preferences" description="Information about your billing plan limits.">
          <ReferenceField source="settings.id" reference="Setting" link="">
            <TextInput disabled fullWidth label="Max Users" source="configuration.max_users" />
          </ReferenceField>
          <ReferenceField source="settings.id" reference="Setting" link="">
            <TextInput disabled fullWidth label="Max Forms" source="configuration.formtopia.max_forms" />
          </ReferenceField>
        </SettingsGroup>
      </div>
    )
  )
}

const AccountHeader: React.FC = () => {
  const [plan, setPlan] = React.useState('')
  const record = useRecordContext()

  return (
    record && (
      <div
        style={{
          display: 'flex',
          flexFlow: 'column nowrap',
        }}
      >
        <Typography.Text
          strong
          style={{
            fontSize: 18,
            lineHeight: 1.66,
          }}
        >
          {record.name}
        </Typography.Text>
        <Typography.Text type="secondary">
          {plan ? `${plan} • ` : ''}
          <Typography.Link href={`#/account/${record.id}/billing`}>View billing</Typography.Link>
        </Typography.Text>
      </div>
    )
  )
}
